import * as React from "react";
import { Row, Col, Button } from "react-bootstrap";
import { connect } from "react-redux";
import { Redirect } from "react-router";
import "../../../assets/sass/components/superAdminAccess.scss";
import { ERROR_MSG, SUCCESS_MSG, FLUSH_NON_PROD_CDN } from "./constant";
import CONSTANT from "../../constants/constantFile";
import AlertMessage from "../../widgets/AlertMessageWidget";
import Popup from "./Popup";
import * as superAdminActionCreators from "./actionCreators";
import { bindActionCreators } from "redux";
import Loader from "../Loader";
import { capitalize } from "../../utils/utils";
class SuperAdmin extends React.Component<any, any> {
    constructor(props) {
        super(props);
        this.state = {
            success: false,
            selectedAction: "Action1",
            isApplyBtnClicked: false,
            showPopup: false,
        };
    }
    componentDidUpdate() {
        if (this.props.showAlert && !this.props.isLoading) {
            setTimeout(() => {
                this.props.superAdminActions.resetReport();
            }, CONSTANT.autoHideToasts);
        }
    }
    refreshRedisCacheHandler = () => {
        this.setState({ isApplyBtnClicked: true, selectedAction: "refresh redis cache", success: false });
        this.props.superAdminActions.refreshRedisCache(this.state);
        return true;
    };
    // getContractorId = () => {
    //     this.setState({
    //         showPopup: true,
    //     });
    // };
    // closePopup = () => {
    //     this.setState({
    //         showPopup: false,
    //     });
    // };
    createFormlayoutJSON = () => {
        // if (contractorId) {
        //     this.setState({
        //         showPopup: false,
        //     });
        //     this.setState({ isApplyBtnClicked: true, selectedAction: "create formlayout JSON", success: false });
        //     this.props.superAdminActions.createFormlayoutJSON({ contractorId });
        // }
        const contractorId = 0;
        this.setState({ isApplyBtnClicked: true, selectedAction: "create formlayout JSON", success: false });
        this.props.superAdminActions.createFormlayoutJSON({ contractorId });
        return true;
    };
    refreshActionScopes = () => {
        this.setState({ isApplyBtnClicked: true, selectedAction: "refresh action scopes", success: false });
        this.props.superAdminActions.refreshActionScopes(this.state);
        return true;
    };
    flushCDN = () => {
        window.open(FLUSH_NON_PROD_CDN, "_blank");
        return true;
    };
    refreshPropertyManagerJson = () => {
        this.setState({ isApplyBtnClicked: true, selectedAction: "refresh propertymanager json", success: false });
        this.props.superAdminActions.refreshPropertyManagerJson(this.state);
        return true;
    };
    apiDeepHealthCheck = () => {
        this.setState({ isApplyBtnClicked: true, selectedAction: "API Deep health check", success: false });
        this.props.superAdminActions.apiDeepHealthCheck(this.state);
        return true;
    }
    renderActions = () => {
        return (
            <div className="gaf-search">
                <Row>
                    <Col md={6}>
                        <div className="btn-actions d-flex justify-content-center">
                            <Button
                                className="btn gaf-btn-primary generate-report-btn"
                                onClick={this.refreshRedisCacheHandler}
                            >
                                Refresh Redis Cache
                            </Button>
                        </div>
                    </Col>
                    <Col md={6}>
                        <div className="btn-actions d-flex justify-content-center">
                            <Button className="btn gaf-btn-primary generate-report-btn" onClick={this.createFormlayoutJSON}>
                                Create Formlayout JSON
                            </Button>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col md={6}>
                        <div className="btn-actions d-flex justify-content-center">
                            <Button
                                className="btn gaf-btn-primary generate-report-btn"
                                onClick={this.refreshActionScopes}
                            >
                                Refresh ActionScopes
                            </Button>
                        </div>
                    </Col>
                    <Col md={6}>
                        <div className="btn-actions d-flex justify-content-center">
                            <Button className="btn gaf-btn-primary generate-report-btn" onClick={this.flushCDN}>
                                Flush CDN
                            </Button>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col md={6}>
                        <div className="btn-actions d-flex justify-content-center">
                            <Button
                                className="btn gaf-btn-primary generate-report-btn"
                                onClick={this.refreshPropertyManagerJson}
                            >
                                Refresh PropertyManager JSON
                            </Button>
                        </div>
                    </Col>
                    <Col md={6}>
                    <div className="btn-actions d-flex justify-content-center">
                            <Button
                                className="btn gaf-btn-primary generate-report-btn"
                                onClick={this.apiDeepHealthCheck}
                            >
                                API DeepHealth Check
                            </Button>
                        </div>
                    </Col>
                </Row>
            </div>
        );
    };
    render() {
        const { userInfo } = this.props;
        const show = Object.keys(userInfo).length && userInfo.isAdmin;
        const selectedAction = this.state.selectedAction;
        const ActionType = capitalize(selectedAction.replace(/([a-z](?=[A-Z]))/g, "$1 "));
        return show ? (
            <main className="super-admin-access-container pt100" id="super-admin-access">
                {this.props.isLoading ? <Loader /> : null}
                {this.props.showAlert ? (
                    <div className="alert-container">
                        <AlertMessage
                            type={this.props.success ? "success" : "error"}
                            message={this.props.success ? SUCCESS_MSG(ActionType) : ERROR_MSG}
                            closeAlert={() => {
                                this.props.superAdminActions.resetReport();
                            }}
                        />
                    </div>
                ) : null}
                {/* {this.state.showPopup ? (
                    <Popup onConfirm={this.createFormlayoutJSON} onCancel={this.closePopup} />
                ) : null} */}
                <div className="super-admin-access-title">Super Admin Features</div>
                <div className="super-admin-access-search">
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 report-search">
                        {this.renderActions()}
                    </div>
                </div>
            </main>
        ) : (
            <Redirect to="/?provider=okta" />
        );
    }
}

export function mapStateToProps(state) {
    return {
        userInfo: state.adminData.userInfo || {},
        isLoading: state.superAdminInfo.isLoading,
        success: state.superAdminInfo.success,
        error: state.superAdminInfo.errors,
        showAlert: state.superAdminInfo.success || !!state.superAdminInfo.errors,
    };
}

export function mapDispatchToProps(dispatch) {
    return {
        superAdminActions: bindActionCreators(superAdminActionCreators, dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(SuperAdmin);
